export const SALES_POSITIONS = ["Sales Associate", "Sales Manager", "General Sales Manager", "F&I Manager", "Finance Director"];
